import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { HorizontalNavBar } from '../NavbarSellerDashboard/HorizontalNavBar';
import { VerticalSidebar } from '../NavbarSellerDashboard/VerticalNavBar';
import styles from './style.module.css';
import FlatButtons from '../FlatButton/FlatButton';
import { SideNavExpandIcon } from '../../assets/svgs';

interface SellerDashboardLayoutProps {
  children?: React.ReactNode;
}

export const SellerDashboardLayout: React.FC<SellerDashboardLayoutProps> = ({ children }) => {
  const location = useLocation();
  const [isVerticalSidebarCollapsed, setIsVerticalSidebarCollapsed] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const getCurrentPageName = (pathname: string): string => {
    const pageNames: Record<string, string> = {
      '/seller-dashboard': 'Dashboard',
      '/orders': 'Order Management',
      '/analytics': 'Analytics',
      '/products': 'Product List',
      '/store': 'Store',
      '/profile': 'Profile',
      '/profile/edit': 'Profile',
      '/preferences': 'Preference Settings'
    };
    return pageNames[pathname] || 'Dashboard';
  };

  const currentPage = getCurrentPageName(location.pathname);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setWindowWidth(width);
      
      if (width <= 1024) {
        setIsVerticalSidebarCollapsed(true);
      } else {
        setIsVerticalSidebarCollapsed(false);
      }
      
      if (width > 600) {
        setIsMobileMenuOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleToggleCollapse = () => {
    if (windowWidth <= 600) {
      // On mobile, close the sidebar
      setIsMobileMenuOpen(false);
    } else if (windowWidth > 1024) {
      // On desktop, toggle collapse
      setIsVerticalSidebarCollapsed(!isVerticalSidebarCollapsed);
    }
  };

  const handleMobileMenuToggle = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleSearch = (query: string) => {
    console.log('Search query:', query);
  };

  const handleVerticalNavItemClick = (itemId: string, path: string) => {
    if (windowWidth <= 600) {
      setIsMobileMenuOpen(false);
    }
    console.log('Navigate to:', path);
  };

  const handleOverlayClick = () => {
    setIsMobileMenuOpen(false);
  };

  return (
        <div className={`${styles.dashboardContainer} ${isVerticalSidebarCollapsed ? styles.sidebarCollapsed : ''} ${isMobileMenuOpen ? styles.mobileMenuOpen : ''}`}>
      {windowWidth <= 600 && !isMobileMenuOpen && (
        <FlatButtons
          className={styles.mobileMenuToggle}
          onClick={handleMobileMenuToggle}
        >
          <img
            src={SideNavExpandIcon}
            alt='sidebar collapse icon'
            className={styles.collapseIcon}
          />
        </FlatButtons>
      )}

      {windowWidth <= 600 && isMobileMenuOpen && (
        <div 
          className={styles.mobileOverlay}
          onClick={handleOverlayClick}
        />
      )}

      <VerticalSidebar
        isCollapsed={isVerticalSidebarCollapsed}
        onToggleCollapse={handleToggleCollapse}
        onItemClick={handleVerticalNavItemClick}
        className={isMobileMenuOpen ? 'mobileOpen' : ''}
        isMobile={windowWidth <= 600}
      />
      
      <div className={styles.mainContent}>
        <HorizontalNavBar
          currentPage={currentPage}
          isVerticalSidebarCollapsed={isVerticalSidebarCollapsed}
          onSearch={handleSearch}
          notificationCount={5}
        />
        <main className={styles.pageContent}>
          {children}
        </main>
      </div>
    </div>
  );
};